export default {"src":"/_next/static/media/404-illustration.840dd744.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};